class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    const productGridContainer = document.getElementById('ProductGridContainer');
    const collectionEl = productGridContainer?.querySelector('.collection');
    if (collectionEl) {
      collectionEl.classList.add('loading');
    }
    if (typeof CollectionInfiniteScroll !== 'undefined') {
      CollectionInfiniteScroll.destroy();
    }
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });

    if (typeof CollectionInfiniteScroll !== 'undefined') {
      CollectionInfiniteScroll.init();
    }
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          document.querySelector(`#${elementToRender.parentElement.id} .js-filter`).before(elementToRender);
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? newFacetDetailsElement.closest('.mobile-facets--accordion')
            ? '.mobile-facets__summary'
            : '.mobile-facets__close-button'
          : '.facets__summary';
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (newElementToActivate && !isTextInput) newElementToActivate.focus();
      }
    }
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  connectedCallback() {
    this.slider = this.querySelector('.facets__price-slider');
    if (!this.slider) return;

    this.progress = this.querySelector('[data-price-progress]');
    this.minRange = this.querySelector('[data-price-range="min"]');
    this.maxRange = this.querySelector('[data-price-range="max"]');
    this.minField = this.querySelector('[data-price-field="min"]');
    this.maxField = this.querySelector('[data-price-field="max"]');

    this.rangeMin = this.toNumber(this.slider.dataset.rangeMin, 0);
    this.rangeMax = this.toNumber(this.slider.dataset.rangeMax, 0);
    // Exact peso steps so max like 74990 is reachable (step 1000 stopped at 74000)
    this.step = 1;
    this.minValue = this.toNumber(this.slider.dataset.minValue, this.rangeMin);
    this.maxValue = this.toNumber(this.slider.dataset.maxValue, this.rangeMax);
    this.activeThumb = 'max';

    this.minValue = Math.min(Math.max(this.minValue, this.rangeMin), this.rangeMax);
    this.maxValue = Math.min(Math.max(this.maxValue, this.rangeMin), this.rangeMax);
    if (this.minValue > this.maxValue) this.minValue = this.rangeMin;

    this.minRange.min = this.rangeMin;
    this.minRange.max = this.rangeMax;
    this.minRange.step = this.step;
    this.maxRange.min = this.rangeMin;
    this.maxRange.max = this.rangeMax;
    this.maxRange.step = this.step;
    this.minField.min = this.rangeMin;
    this.minField.max = this.rangeMax;
    this.minField.step = this.step;
    this.maxField.min = this.rangeMin;
    this.maxField.max = this.rangeMax;
    this.maxField.step = this.step;

    this.onMinRangeInput = this.onMinRangeInput.bind(this);
    this.onMaxRangeInput = this.onMaxRangeInput.bind(this);
    this.onMinFieldChange = this.onMinFieldChange.bind(this);
    this.onMaxFieldChange = this.onMaxFieldChange.bind(this);
    this.onMinFieldKeyDown = this.onKeyDown.bind(this);
    this.onMaxFieldKeyDown = this.onKeyDown.bind(this);
    this.onTrackHover = this.onTrackHover.bind(this);
    this.onActivateMin = () => this.setActiveThumb('min');
    this.onActivateMax = () => this.setActiveThumb('max');

    this.minRange.addEventListener('input', this.onMinRangeInput);
    this.maxRange.addEventListener('input', this.onMaxRangeInput);
    this.minRange.addEventListener('pointerdown', this.onActivateMin);
    this.maxRange.addEventListener('pointerdown', this.onActivateMax);
    this.minField.addEventListener('change', this.onMinFieldChange);
    this.maxField.addEventListener('change', this.onMaxFieldChange);
    this.minField.addEventListener('keydown', this.onMinFieldKeyDown);
    this.maxField.addEventListener('keydown', this.onMaxFieldKeyDown);
    this.slider.addEventListener('pointermove', this.onTrackHover);

    this.syncUI(false);
  }

  disconnectedCallback() {
    if (!this.minRange) return;

    this.minRange.removeEventListener('input', this.onMinRangeInput);
    this.maxRange.removeEventListener('input', this.onMaxRangeInput);
    this.minRange.removeEventListener('pointerdown', this.onActivateMin);
    this.maxRange.removeEventListener('pointerdown', this.onActivateMax);
    this.minField.removeEventListener('change', this.onMinFieldChange);
    this.maxField.removeEventListener('change', this.onMaxFieldChange);
    this.minField.removeEventListener('keydown', this.onMinFieldKeyDown);
    this.maxField.removeEventListener('keydown', this.onMaxFieldKeyDown);
    this.slider.removeEventListener('pointermove', this.onTrackHover);
  }

  toNumber(value, fallback = 0) {
    const parsed = Number(String(value ?? '').replace(/[^\d.-]/g, ''));
    return Number.isFinite(parsed) ? parsed : fallback;
  }

  setActiveThumb(thumb) {
    this.activeThumb = thumb;
    this.minRange.classList.toggle('is-active', thumb === 'min');
    this.maxRange.classList.toggle('is-active', thumb === 'max');
  }

  onTrackHover(event) {
    if (!this.minRange || !this.maxRange || this.rangeMax <= this.rangeMin) return;

    const rect = this.minRange.getBoundingClientRect();
    if (!rect.width) return;

    const ratio = (event.clientX - rect.left) / rect.width;
    const pointerValue = this.rangeMin + ratio * (this.rangeMax - this.rangeMin);
    const distMin = Math.abs(pointerValue - this.minValue);
    const distMax = Math.abs(pointerValue - this.maxValue);

    this.setActiveThumb(distMin < distMax ? 'min' : 'max');
  }

  onMaxRangeInput(event) {
    event.stopPropagation();
    let value = this.toNumber(event.currentTarget.value);
    // Keep thumbs from collapsing into a zero-width filter by accident
    if (value < this.minValue) value = this.minValue;
    if (value >= this.rangeMax) value = this.rangeMax;
    this.maxValue = value;
    this.syncUI(true);
  }

  onMinRangeInput(event) {
    event.stopPropagation();
    let value = this.toNumber(event.currentTarget.value);
    if (value > this.maxValue) value = this.maxValue;
    if (value <= this.rangeMin) value = this.rangeMin;
    this.minValue = value;
    this.syncUI(true);
  }

  onMinFieldChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.minValue = Math.min(this.toNumber(event.currentTarget.value, this.rangeMin), this.maxValue);
    this.syncUI(true);
  }

  onMaxFieldChange(event) {
    this.adjustToValidValues(event.currentTarget);
    const parsed = event.currentTarget.value === '' ? this.rangeMax : this.toNumber(event.currentTarget.value, this.rangeMax);
    this.maxValue = Math.max(parsed, this.minValue);
    this.syncUI(true);
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  syncUI(dispatchEvent) {
    this.minRange.value = String(this.minValue);
    this.maxRange.value = String(this.maxValue);

    const atMinDefault = this.minValue <= this.rangeMin;
    const atMaxDefault = this.maxValue >= this.rangeMax;

    this.minField.value = atMinDefault ? '' : String(this.minValue);
    this.maxField.value = atMaxDefault ? '' : String(this.maxValue);
    this.minField.placeholder = String(this.rangeMin);
    this.maxField.placeholder = String(this.rangeMax);

    this.minField.setAttribute('data-max', String(this.maxValue));
    this.maxField.setAttribute('data-min', String(this.minValue));

    this.updateProgress();

    if (dispatchEvent) {
      this.minField.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  updateProgress() {
    if (!this.progress || this.rangeMax <= this.rangeMin) {
      if (this.progress) {
        this.progress.style.left = '0%';
        this.progress.style.right = '0%';
      }
      return;
    }

    const leftPercent = ((this.minValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;
    const rightPercent = 100 - ((this.maxValue - this.rangeMin) / (this.rangeMax - this.rangeMin)) * 100;

    this.progress.style.left = `${leftPercent}%`;
    this.progress.style.right = `${rightPercent}%`;
  }

  adjustToValidValues(input) {
    if (input.value === '') return;

    const value = this.toNumber(input.value);
    const min = this.toNumber(input.getAttribute('data-min'), this.rangeMin);
    const max = this.toNumber(input.getAttribute('data-max'), this.rangeMax);

    if (value < min) input.value = String(min);
    if (value > max) input.value = String(max);
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);
